import React, { Component } from "react";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import { Button } from 'reactstrap';

export class Confirmation extends Component {
  render() {
    const {
      initialModalState,
      onAccept,
      onCancel,
      message,
      titleAccept,
      titleCancel,
      confirmType,
      iconType
    } = this.props;

    return (
      <Modal
        backdrop="static"
        show={initialModalState}
        onAccept={onAccept}
        onCancel={onCancel}
        onHide={onCancel}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        dialogClassName="modal"
        className="confirmation-modal"
        animation={false}>
        <Modal.Header className={confirmType}>
          <span className={iconType}></span>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex align-items-center justify-content-center h-100">
            <h5 className="text-color-grey-800 inter-regular-16">
              {message}
            </h5>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {titleCancel &&
            <Button
              className="btn-outline-primary"
              title={titleCancel}
              color="secondary"
              onClick={() => {
                if (this.props.onCancel) {
                  this.props.onCancel();
                }
              }}
            >
              {titleCancel}
            </Button>
          }
          {titleAccept &&
            <Button
              id="modify"
              className="ml-1"
              color="primary"
              title={titleAccept}
              onClick={() => {
                if (this.props.onAccept) {
                  this.props.onAccept();
                }
              }}
            >
              {titleAccept}
            </Button>
          }
        </Modal.Footer>
      </Modal>
    );
  }
}

Confirmation.propTypes = {
  initialModalState: PropTypes.bool.isRequired,
  onAccept: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  message: PropTypes.string
};
